import MainLayout from '../layouts/main';
import ProfileContainer from './container';

function ProfilePage() {
  const title = 'پروفایل';

  return (
    <MainLayout title={title} consultPackageRequired={false} packageRequired={false}>
      <ProfileContainer/>
    </MainLayout>
  );
}

export default ProfilePage;
